{
  "variableRetention": "Variable Retention",
  "title": "Variable Retention Rules",
  "description": "Control how many days logs are retained by creating Variable Retention rules. New log lines that match a Variable Retention rule will be stored for a different retention duration than the default retention duration.",
  "priorityTooltip": "Rules with lower priority numbers take precedence over rules with higher priority numbers when a log line matches multiple rules.",
  "noResultsTitle": "No Results Found",
  "noResultsMessage": "The filters selected returned no results.",
  "noDataTitle": "No Variable Retention Rules Created Yet",
  "noDataMessage": "Click “Add Rule” above to start creating a new Variable Retention rule.",
  "listError": "Unable to fetch the Variable Retention Rules.",
  "removeError": "Unable to remove the Variable Retention Rule.",
  "addNew": "Add Rule",
  "backToList": "Back to Retention Rules List",
  "name": "Name",
  "descriptionPlaceholder": "Name your variable retention rule",
  "hosts": "Hosts",
  "apps": "Apps",
  "levels": "Levels",
  "query": "Query",
  "hostsPlaceholder": "Add hosts to your retention rule",
  "appsPlaceholder": "Add apps to your retention rule",
  "levelsPlaceholder": "Add levels to your retention rule",
  "queryPlaceholder": "Add a query to your retention rule",
  "period": "Retention Period",
  "periodPlaceholder": "Choose retention time frame",
  "saveError": "Unable to save the Retention rule.  Please try again.",
  "savePriorityError": "Unable to update the Retention rule priority.  Please try again.",
  "priority": "Priority",
  "planRetention": "Plan retention",
  "searchPlaceholder": "Search rules...",
  "deleteModalTitle": "Are you sure you want to delete the <strong>{{description}}</strong> retention rule?",
  "changesWarning": "It may take up to 5 minutes for a new rule or rule changes to take effect.",
  "changePriority": "Change Priority",
  "form": {
    "title": "Add Variable Retention Rule",
    "description": "Control how many days logs are retained by creating Variable Retention rules. New log lines that match the conditions defined below will be stored for a different retention duration than the default retention duration."
  },
  "dayVariableRetention": "{{period}} day variable retention",
  "dayPlanRetention": "{{period}} day plan retention",
  "dayRetention": "{{period}} day retention",
  "contractErrorsAlert": "<strong>{{count}} Rules</strong> need to be edited, due to the change of retention periods."
}
